import React from 'react'
import './Tag.scss'

const Tag = ({ type = 'neutral', inverse = false, children, className = '' }) => {
  return (
    <span className={`status-tag status-tag--${type} ${inverse ? 'status-tag--inverse' : ''} ${className}`.trim()}>
      {children}
    </span>
  )
}

export default Tag
